<template>
    <Modal2
        :title="$t('message.selectFile')"
        :description="multiple ? 'Birden fazla dosya seçebilirsiniz' : 'Bir dosya seçin'"
        @cancel="handleCancel"
        @ok="handleConfirm"
        class-name="file-picker-modal"
    >
        <div class="file-picker">
            <div class="breadcrumb">
                <a-breadcrumb>
                    <a-breadcrumb-item v-for="(folder, index) in breadcrumbFolders" :key="folder._id">
                        <a href="#" @click.prevent="navigateToFolder(folder._id)">{{ folder.name }}</a>
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <div class="files-container">
                <FileCard
                    v-for="file in currentFiles"
                    :key="file._id"
                    :file="file"
                    :readonly="true"
                    :selectionMode="true"
                    :selected="isFileSelected(file)"
                    @doubleClick="handleDoubleClick"
                    @click.native="toggleFileSelection(file)"
                />
            </div>
        </div>
    </Modal2>
</template>

<script>
import Vue from "vue";
import FileCard from "./FileCard.vue";
import Modal2 from "../../../components/common/Modal2.vue";
import { DRIVE_API } from "../../../api/drive";

export default Vue.extend({
    name: "FilePicker",
    components: {
        Modal2,
        FileCard,
    },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            folders: [],
            currentFolderId: null,
            currentFiles: [],
            breadcrumbFolders: [],
            selectedFiles: [],
        };
    },
    async created() {
        await this.fetchFolders();
        if (this.folders.length > 0) {
            const rootFolder = this.folders.find((f) => f.parent === null);
            if (rootFolder) {
                this.currentFolderId = rootFolder._id;
                await this.fetchCurrentFolderFiles();
            }
        }
    },
    methods: {
        async fetchFolders() {
            try {
                this.folders = await DRIVE_API.listAllFolders();
                if (!this.currentFolderId) this.showRootFolder();
                this.updateBreadcrumb();
            } catch (error) {
                console.error("Klasörler yüklenirken hata:", error);
            }
        },
        showRootFolder() {
            const root = this.folders.find((f) => f.parent === null);
            if (root) {
                this.currentFolderId = root._id;
            }
        },
        async fetchCurrentFolderFiles() {
            if (!this.currentFolderId) return;
            try {
                this.currentFiles = await DRIVE_API.listFilesByFolderId(this.currentFolderId);
            } catch (error) {
                console.error("Dosyalar yüklenirken hata:", error);
            }
        },
        updateBreadcrumb() {
            const currentFolder = this.folders.find((f) => f._id === this.currentFolderId);
            const breadcrumbFolders = [];

            let folder = currentFolder;
            while (folder) {
                breadcrumbFolders.unshift(folder);
                folder = this.folders.find((f) => f._id === folder.parent);
            }

            this.breadcrumbFolders = breadcrumbFolders;
        },
        navigateToFolder(folderId) {
            this.currentFolderId = folderId;
            this.selectedFiles = [];
        },
        handleDoubleClick(file) {
            if (file.isFolder) {
                this.navigateToFolder(file._id);
            }
        },
        toggleFileSelection(file) {
            if (file.isFolder) return;

            const index = this.selectedFiles.findIndex((f) => f._id === file._id);
            if (index !== -1) {
                this.selectedFiles.splice(index, 1);
            } else {
                if (this.multiple) {
                    this.selectedFiles.push(file);
                } else {
                    this.selectedFiles = [file];
                }
            }
        },
        isFileSelected(file) {
            return this.selectedFiles.some((f) => f._id === file._id);
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleConfirm() {
            if (this.selectedFiles.length > 0) {
                this.$emit("confirm", this.selectedFiles);
            }
        },
    },
    watch: {
        currentFolderId() {
            this.fetchCurrentFolderFiles();
            this.updateBreadcrumb();
        },
    },
});
</script>

<style scoped lang="scss">
.file-picker {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .breadcrumb {
        margin-bottom: 10px;
    }

    .files-container {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        .file-card {
            &.selected {
                border: 2px solid #1890ff;
            }
        }
    }
}
</style>
<style lang="scss">
.file-picker-modal {
    .ant-modal {
        width: 800px !important;
        max-width: 90vw !important;
        max-height: 90vh !important;
        overflow: auto;
    }
}
</style>
